import { render, staticRenderFns } from "./TrackingHistory.vue?vue&type=template&id=60c62130&"
import script from "./TrackingHistory.vue?vue&type=script&lang=ts&"
export * from "./TrackingHistory.vue?vue&type=script&lang=ts&"
import style0 from "./TrackingHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports